"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const drivingLicenceHelpers = {
    validateLastNameSection(lastName, licencePart) {
        if (!lastName || !licencePart) {
            return false;
        }
        const formatName = lastName.replace(/\s|-|'/g, "");
        let lastNameStart = formatName.length >= 5 ? formatName.substring(0, 5).toUpperCase() : formatName.toUpperCase();
        if (formatName.length < 5) {
            for (let i = lastNameStart.length; i < 5; i++) {
                lastNameStart = lastNameStart + "9";
            }
        }
        if (formatName.toUpperCase().startsWith("MAC")) {
            if (formatName.length >= 6) {
                lastNameStart = "MC" + formatName.substring(3, 6).toUpperCase();
            }
            else {
                lastNameStart = "MC" + formatName.substring(3).toUpperCase();
                for (let i = lastNameStart.length; i < 5; i++) {
                    lastNameStart = lastNameStart + "9";
                }
            }
        }
        return lastNameStart === licencePart;
    },
    validateBirthDateSection(dateOfBirth, licencePart, title) {
        if (!dateOfBirth || !licencePart) {
            return false;
        }
        const digitRegex = /^\d+$/;
        if (!digitRegex.test(licencePart)) {
            return false;
        }
        const date = moment.utc(dateOfBirth, moment.ISO_8601);
        const decadeNumber = date.year().toString().substring(2, 3);
        const yearNumber = date.year().toString().substring(3);
        const month = date.month() + 1;
        const licenceMonth = licencePart.substring(1, 3);
        const dayOfMonth = date.date() < 10 ? "0" + date.date().toString() : date.date().toString();
        const femaleTitles = ["MISS", "MS", "MRS", "DR"];
        const currentMonthEqualToLicenseMonth = month.toString() === licenceMonth || "0" + month.toString() === licenceMonth;
        let monthValid;
        if (title === "DR" || title === "none") {
            monthValid = (month + 50).toString() === licenceMonth || currentMonthEqualToLicenseMonth;
        }
        else if (femaleTitles.includes(title)) {
            monthValid = (month + 50).toString() === licenceMonth;
        }
        else {
            monthValid = currentMonthEqualToLicenseMonth;
        }
        return decadeNumber === licencePart.substring(0, 1) && yearNumber === licencePart.substring(5) &&
            monthValid && dayOfMonth === licencePart.substring(3, 5);
    },
    validateFirstNameSection(firstName, licencePart) {
        if (!firstName || !licencePart) {
            return false;
        }
        const names = firstName.split(" ");
        const firstNameInitial = names[0].substring(0, 1).toUpperCase();
        return firstNameInitial === licencePart.substring(0, 1);
    }
};
exports.default = drivingLicenceHelpers;
//# sourceMappingURL=drivingLicenceHelpers.js.map